/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";
import {
  OutlinedInput,
  Button,
  Dialog,
  DialogTitle,
  DialogContentText,
 } from "@mui/material";

export const StyledTitle = styled('h1')({
  fontWeight: '400',
  fontSize: '2.375rem !important',
  margin: '0px',
})

export const StyledSubTitle = styled('p')({
  fontSize: '15px',
  margin: '20px 0px',
  letterSpacing: '0.2px',
  lineHeight: '1.5',
})

export const StyledFormContainer = styled('div')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
})

export const StyledPasswordField = styled(OutlinedInput)({
  '@media (max-width: 450px)':{
    width: '350px'
  },
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '2px solid #395bbd !important'
    },
  },
  width: '100%',
  borderRadius: '8px',
  height: '40px !important',
  paddingTop: '3px',
  fontSize: '15px',
})

export const  StyledResetButton = styled(Button)({
  '&.Mui-disabled':{
    backgroundColor: '#ebebeb',
  },
  '&:hover': {
    backgroundColor: '#001b59',
    borderRadius: '8px',
  },
  textTransform: 'none',
  width: '100%',
  height: '40px',
  backgroundColor: '#395bbd',
  boxShadow: 'none',
  marginTop: '15px',
  marginBottom: '20px',
  color: 'white',
  borderRadius: '8px',
})

export const StyledHelperText = styled('div')({
  color: '#d32f2f',
  fontSize: '0.75rem',
  paddingTop: '5px',
  letterSpacing: "0.3px"
})

export const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root':{
    minWidth: '500px !important'
  }
})

export const StyledErrorTitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '25px',
})

export const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: '600',
  fontSize: '22px',
  padding: '13px 0px 5px 15px !important',
})

export const StyledList = styled('ul')({
  paddingLeft: '15px !important',
  fontSize: '12px',
  color: '#5b5b5b',
  letterSpacing: '0.25px',
})

export const ResetPasswordWrapper = styled('div')({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
})

export const StyledBackToLoginButton = styled(Button)({
  '&:hover': {
    textTransform: 'none',
    fontWeight: '600',
    boxShadow: 'none',
    border: '2px solid #001b59',
    borderRadius: '8px',
    color: '#001b59',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  border: '2px solid #395bbd',
  borderRadius: '8px',
  color: '#395bbd',
  width: '100%',
  height: '40px',
  marginTop: '15px',
  marginBottom: '20px',
})

export const StyledInstructions = styled('ul')({
  paddingLeft: '15px !important',
  fontSize: '12px',
  color: '#5b5b5b',
  letterSpacing: '0.25px',
  margin: '5px 0px 0px 0px',
})

export const FormFieldTitle = styled('p')({
  fontWeight: '600',
  margin: '0px 0px 7px 0px',
  fontSize: '15px',
  color: '#252525',
})

export const CarouselContainer = styled('div')({
  '@media (max-width: 1100px)': {
    display: 'none',
  },
  height: '100vh',
  width: '60%',
})

export const FormContainer = styled('div')({
  '@media (max-width: 1000px)': {
    width: '400px !important',
  },
  height: '100%',
  width: '40%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const FormWrapper = styled('div')({
  '@media (max-width: 420px)': {
    width: '360px !important',
  },
  width: '530px',
  padding: '5px',
})

export const PasswordInstructionTitle = styled('p')({
  margin: '0',
  fontSize: '13px',
  color: 'grey',
  fontWeight: '600',
})

export const PasswordErrorText = styled(DialogContentText)({
  fontSize: '15px',
  color: '#535353',
  marginTop: '-10px'
})

export const PasswordDescriptionTitle = styled(DialogContentText)({
  fontSize: '12px',
  color: '#535353',
  marginTop: '10px',
})
